import sortBy from 'lodash/sortBy';

export const combineShopifyOrderByDate = (arraysOfOrders) => {
  const orders = Array.prototype.concat(...arraysOfOrders);

  return sortBy(orders, (order) => order['created_at']).reverse();
};

export const addShopNameToOrder = (orders, shopName) => {
  return orders.map((order) => {
    return {
      ...order,
      shopName,
    };
  });
};
